import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnderline = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.16602 17.5V15.8333H15.8327V17.5H4.16602ZM9.99935 14.1667C8.59657 14.1667 7.50629 13.7292 6.72852 12.8542C5.95074 11.9792 5.56185 10.8194 5.56185 9.375V2.5H7.70768V9.5C7.70768 10.2778 7.90213 10.9097 8.29102 11.3958C8.6799 11.8819 9.24935 12.125 9.99935 12.125C10.7493 12.125 11.3188 11.8819 11.7077 11.3958C12.0966 10.9097 12.291 10.2778 12.291 9.5V2.5H14.4368V9.375C14.4368 10.8194 14.048 11.9792 13.2702 12.8542C12.4924 13.7292 11.4021 14.1667 9.99935 14.1667Z",
		fill: "#636566"
	})]
});
const ForwardRef = forwardRef(SvgUnderline);
export { ForwardRef as ReactComponent };
